/**
 * PasswordRequirements Component
 *
 * Displays password validation requirements with visual feedback.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/auth.css";

const PasswordRequirements = ({ validation }) => {
  const { t } = useTranslation();

  if (!validation || !validation.show) return null;

  return (
    <div className="password-requirements">
      <small className={validation.length ? "valid" : ""}>
        {t('passwordRequirements.length')}
      </small>
      <small className={validation.uppercase ? "valid" : ""}>
        {t('passwordRequirements.uppercase')}
      </small>
      <small className={validation.lowercase ? "valid" : ""}>
        {t('passwordRequirements.lowercase')}
      </small>
      <small className={validation.number ? "valid" : ""}>
        {t('passwordRequirements.number')}
      </small>
      <small className={validation.special ? "valid" : ""}>
        {t('passwordRequirements.special')}
      </small>
    </div>
  );
};

export default PasswordRequirements;
